export default function Hero() {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/ab19722ff2fbe9d917a6fb25b6cde9ef.jpg" 
          alt="Hero Background" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-8 flex items-center">
        <div className="w-2/5">
          <h1 className="text-7xl font-light text-white leading-tight mb-8" style={{ textShadow: '0 2px 20px rgba(0,0,0,0.3)' }}>
            Modern iOS<br />
            Applications for<br />
            Enhanced Security
          </h1>
        </div>
      </div>

      {/* Bottom Descriptive Area */}
      <div className="absolute bottom-20 left-0 right-0">
        <div className="max-w-7xl mx-auto px-8 flex justify-between items-end">
          <div className="w-80">
            <p className="text-white text-base font-light" style={{ textShadow: '0 1px 10px rgba(0,0,0,0.5)' }}>
              VPN solutions designed for privacy-conscious users
            </p>
          </div>
          <div className="w-80 mb-8">
            <p className="text-white text-base font-light" style={{ textShadow: '0 1px 10px rgba(0,0,0,0.5)' }}>
              Cleaner tools optimizing device performance
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
